import React from 'react'
import _ from 'lodash';
import { useSelector } from 'react-redux';
import { Button } from 'react-bootstrap';

import showToastNotification from './../../../widgets/toastify';
import * as Constants from './../../../../helpers/constants';
import { ApiHelper } from '../../../../helpers/apihelper';

const ForgotPasswordLink = ({ userData, client }) => {
  const userName = useSelector(state => state.user.name);
  const id = useSelector((state) => state.user.id);

  function onGetForgotPasswordLink() {
    const requestBody = {
      co_user_id: userData.user_id,
      user_id: userData.user_id,
      action_type: 'forgot_password',
      client_secret: Constants.CLIENT_SECRET,
      crm_user_data: {
        user_id: id,
        name: userName
      },
      crm_user_id: id
    };

    let body = _.pick(requestBody, ApiHelper(client, 'FORGOT_PASSWORD_LINK').API_BODY)
    ApiHelper(client, 'FORGOT_PASSWORD_LINK').API(client, body)
      .then((response) => {
        if (response.status === Constants.CO_API.FAILED) {
          showToastNotification({
            message: 'Password Link copied unsuccessfully',
            isSuccess: false,
          });
        } else if (response.status === Constants.CO_API.SUCCESS) {
          navigator.clipboard.writeText(response.data.reset_url)
          showToastNotification({
            message: 'Password Link copied successfully',
            isSuccess: true,
          });
        }
      })
      .catch((error) => {
        console.log(error)
      })
  }
  return (
    <Button
      variant='outline-primary'
      className="w-100 mb-2 forgot-password-btn"
      onClick={onGetForgotPasswordLink}
    >
      Get Forgot Password Link
    </Button>
  )
}

export default ForgotPasswordLink